import axios from 'ui/utils/axios';
import { IError } from 'ui/interfaces/entities/apiError';
import { ICard, IMeta, IContext } from 'ui/interfaces/entities/clinical';

export namespace POST {
  export interface IResponse {
    data: ICard[];
    meta: IMeta;
  }
  export type IRequest = IContext;
  export type IResponseError = IError;

  export const getUrl = () => `/sidebar/clinical/config`;

  export const service = (body: IRequest) => axios.post<IResponse>(getUrl(), body);
}
